<template>
    <div>
        <info v-if="!$route.query.viewMsg"></info>
        <msg v-else></msg>
    </div>
</template>

<script>
/**
 * @file law-info.vue
 * @author baoleilei
 * @desc 我的首页
 */
import info from './info.vue';
import msg from '../../../pages/law-info/views/msg.vue';

export default {
    name: 'lawinfo',
    components: {
        info,
        msg
    }
};
</script>
